/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Distribute_Point_1Inputs */

const en_landing_step_distribute_point_1 = /** @type {(inputs: Landing_Step_Distribute_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signals matched to client profiles`)
};

/**
* | output |
* | --- |
* | "Signals matched to client profiles" |
*
* @param {Landing_Step_Distribute_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_distribute_point_1 = /** @type {((inputs?: Landing_Step_Distribute_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Distribute_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_distribute_point_1(inputs)
});